import * as React from "react";
import styles from "./Study.css";
import { Icon } from "semantic-ui-react";
import StatusDisplay from "./StudyStatusIcon";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const Study = ({ study, close, dictionary }) => {
	return (
		<div className={`ui card ${styles.studyCard}`} key={`study-${study.number}`}>
			<div className="content">
				<div className="description">
					<div className={styles.closeButton}><Icon onClick={() => close()}><i
						aria-hidden="true"
						className="red times icon"
					                                                                  /></Icon>
					</div>
					<p><span className={styles.bold}>{dictionary?.study || "Study"}:</span> {study.number}</p>
					<p><span className={styles.bold}>{dictionary?.title || "Title"}:</span> {study.title}</p>
					<p><span className={styles.bold}>{dictionary?.approvalDate || "Approval Date"}:</span> {study.approvalDate}</p>
					<p><span className={styles.bold}>{dictionary?.expireDate || "Exp. Date"}:</span> {study.expireDate}</p>
					<p><span className={styles.bold}>{dictionary?.primaryInvestigator || "PI"}:</span> {study.primaryInvestigator}</p>
					<p><span className={styles.bold}>{dictionary?.status || "Status"}:</span> <StatusDisplay status={study.status}/></p>
				</div>
			</div>
		</div>
	);
};

Study.propTypes = {
	study: PropTypes.shape({
		id: PropTypes.string,
		number: PropTypes.string,
		title: PropTypes.string,
		approvalDate: PropTypes.string,
		expireDate: PropTypes.string,
		primaryInvestigator: PropTypes.string,
		status: PropTypes.string
	}),
	close: PropTypes.func
};

const mapStateToProps = state => ({
	dictionary: state.dictionary.irbStudy
});

export default connect(mapStateToProps)(Study);
